import React from 'react'
import { Sentiment } from '../types'

interface SentimentIndicatorProps {
	sentiment: Sentiment
	size?: number
	translations?: Record<string, string> | null
}

const SENTIMENT_COLORS: Record<string, string> = {
	positive: '#19DA8F',
	neutral: '#A7A7A7',
	negative: '#FF4955',
	none: '#FBC02D',
}

export const getSentimentColor = (sentiment: Sentiment): string => {
	if (sentiment === 1) return SENTIMENT_COLORS.positive
	if (sentiment === 0) return SENTIMENT_COLORS.neutral
	if (sentiment === -1) return SENTIMENT_COLORS.negative
	return SENTIMENT_COLORS.none // null
}

export const getSentimentLabel = (sentiment: Sentiment, translations?: Record<string, string> | null): string => {
	if (sentiment === 1) return translations?.positive || 'Positive'
	if (sentiment === 0) return translations?.neutral || 'Neutral'
	if (sentiment === -1) return translations?.negative || 'Negative'
	return translations?.noSentiment || 'No sentiment'
}

const SentimentIndicator: React.FC<SentimentIndicatorProps> = ({ sentiment, size = 14, translations }) => {
	const color = getSentimentColor(sentiment)

	return (
		<div
			className="rounded-md shrink-0"
			style={{
				backgroundColor: color,
				width: `${size}px`,
				height: `${size}px`,
			}}
			title={getSentimentLabel(sentiment, translations)}
		/>
	)
}

export default SentimentIndicator
